export default __webpack_public_path__ + "static/media/36I-102612_-17033_0.db98351e.jpg";